/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Pressuresetpoint1Inputs */



/**
* | output |
* | --- |
* | "Pressure setpoint" |
*
* @param {Ahu_History_Key_Pressuresetpoint1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_pressuresetpoint1 = /** @type {((inputs?: Ahu_History_Key_Pressuresetpoint1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Pressuresetpoint1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pressure setpoint")
	return /** @type {LocalizedString} */ ("Consigne de pression")
});
export { ahu_history_key_pressuresetpoint1 as "ahu_history_key_pressureSetpoint" }